// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"26":"d65e6eeb","57":"c3cec798","58":"c9045c3e","447":"06534615","453":"962d40fd","475":"bbbdb121","484":"9555fdec","616":"8834570b","765":"b5a42cb1","795":"ffadfbad","881":"4b887bb3"}[chunkId] + ".chunk.js";
};